import { TabContext, TabList, TabPanel } from '@material-ui/lab';
import { Tab } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { useMemo, useState } from 'react';
import { ModalSideBar } from '@webapps/reactjs-tech-components';
import RecordSidebarHeader from './components/RecordSidebarHeader';
import Accounting from './components/Accounting/index';
import Overview from './components/Overview';
import ConventionAndCerfa from './components/ConventionAndCerfa';
import Document from './components/Document';

const RecordSidebar = ({ open, handleClose, opcoRecord, refetch }) => {

  const { classes, global, css } = useStyles(styles);
  const [tabValue, setTabValue] = useState('1');
  const [openAddEmployerAccordion, setOpenAddEmployerAccordion] = useState(false);

  const [invalidCounts, setInvalidCounts] = useState({
    employer: 0,
    student: 0,
    master: 0,
    contract: 0,
    training: 0,
  });

  const reportInvalid = (sectionKey, count) => {
    setInvalidCounts(prev => ({ ...prev, [sectionKey]: count }));
  };

  const totalInvalid = useMemo(
    () => Object.values(invalidCounts).reduce((sum, count) => sum + (count || 0), 0),
    [invalidCounts]
  );

  console.log(opcoRecord)

  return (
    <ModalSideBar open={open} handleClose={handleClose} title={<RecordSidebarHeader applicant={opcoRecord?.individual} contractId={opcoRecord?.recordInternalId} width={80} height={80} />} width="50%" >
      <TabContext value={tabValue}>
        <TabList className={classes.tabContainer} indicatorColor="default" onChange={(e, v) => setTabValue(v)} >
          <Tab className={[global.mainTitle, global.tab, global.thinTab, tabValue === '1' && global.activeTab]} label="Vue d'ensemble" value="1" />
          <Tab className={[global.mainTitle, global.tab, global.thinTab, tabValue === '2' && global.activeTab]} label="Convention et CERFA" value="2" />
          <Tab className={[global.mainTitle, global.tab, global.thinTab, tabValue === '3' && global.activeTab]} label="Comptabilité" value="3" disabled />
          <Tab className={[global.mainTitle, global.tab, global.thinTab, tabValue === '4' && global.activeTab]} label="Documents" value="4" />
        </TabList>
        <TabPanel className={[global.tabPanel, css({ padding: 0, marginTop: 40 })]} value="1" >
          <Overview opcoRecord={opcoRecord} refetch={refetch} invalidCounts={invalidCounts} totalInvalid={totalInvalid} setTabValue={setTabValue} setOpenAddEmployerAccordion={setOpenAddEmployerAccordion} />
          <ConventionAndCerfa hidden={true} opcoRecord={opcoRecord} refetch={refetch} reportInvalid={reportInvalid} invalidCounts={invalidCounts} totalInvalid={totalInvalid} openAddEmployerAccordion={openAddEmployerAccordion} setOpenAddEmployerAccordion={setOpenAddEmployerAccordion} />
        </TabPanel>
        <TabPanel className={[global.tabPanel, css({ padding: 0, marginTop: 40 })]} value="2" >
          <ConventionAndCerfa opcoRecord={opcoRecord} refetch={refetch} reportInvalid={reportInvalid} invalidCounts={invalidCounts} totalInvalid={totalInvalid} openAddEmployerAccordion={openAddEmployerAccordion} setOpenAddEmployerAccordion={setOpenAddEmployerAccordion} />
        </TabPanel>
        <TabPanel className={[global.tabPanel, css({ padding: 0, marginTop: 40 })]} value="3" >
          <Accounting opcoRecord={opcoRecord} refetch={refetch} />
        </TabPanel>
        <TabPanel className={[global.tabPanel, css({ padding: 0, marginTop: 40 })]} value="4" >
          <Document opcoRecord={opcoRecord} refetch={refetch} />
        </TabPanel>
      </TabContext>
    </ModalSideBar>
  );
};

const styles = ({ }) => ({

});

export default RecordSidebar;